export const KEEPER_ERA_QUESTIONS = {
  Anna: 'Does the three-ring co-leader pay for safety, or hunt for a cheaper way to stay annoying?',
  Kyle: 'Does the original dynasty keep a premium name, or try to manufacture one more discount-era title?',
  Kevin: 'Does the 2023 glitch champion chase ceiling, or admit the keeper rule can also punish nostalgia?',
  Samuel: 'Does the vibes department finally make a cold-blooded value pick?',
  Bryan: 'Does the grinder keep a steady producer, or gamble on upside because steady has not bought a ring?',
  'A.J.': 'Does the gunslinger pay for fireworks, or take the boring value and pretend it was his plan?',
  Josh: 'Does Daddy keep a star, or overthink the discount aisle until the group chat notices?',
  Amir: 'Does the strategic mind find the quiet value everyone else missed?',
  Robby: 'Does the commissioner pick like a manager, or rule that his own keeper is obviously legal?',
  Ryan: 'Does the almost guy keep a floor, a ceiling, or whatever finally survives the playoffs?',
  Blake: 'Alumni file: no keeper decision pending, just a clean historical receipt.',
  Alex: 'Alumni file: one La Liga season, playoff cameo, no keeper business.',
  'Harrison Williams': 'Alumni file: one 10-4 season with Peyton Manning, then gone. Nothing pending.',
  'Michael R': 'Alumni file: no keeper decision pending, only the two-season legend.',
};

export function keeperEraQuestionFor(manager) {
  return KEEPER_ERA_QUESTIONS[manager] || 'What does the first keeper era ask this manager to prove?';
}
